import useStatsigVariant from './use-statsig-variant';
import { EXISTED_STATSIG_AB_TESTS } from '../../constants/ab-tests/ab-tests';

const usePreselectedPaymentMethodAbtest = (): boolean => {
    return useStatsigVariant(EXISTED_STATSIG_AB_TESTS.preselectedPaymentMethod) === 'B';
};

export default usePreselectedPaymentMethodAbtest;
